export function normalizeBce(val) {
  if (!val) return '';
  let text = String(val).replace(/\./g, '');
  const num = Number(text);
  if (!Number.isNaN(num)) {
    const s = String(num);
    if (!s.startsWith('0') && s.length === 9) {
      text = '0' + s;
    } else {
      text = s;
    }
  }
  return text;
}

export function isBceLengthValid(s) {
  return /^\d{9,10}$/.test(String(s || ''));
}